module.exports = __webpack_public_path__ + "static/media/tnadrai.efbaf63e.jpg";